<!--  -->
<template>
  <div class="box">
    <img src="~@/assets/images/active/active20230406/1.png" alt="" />
    <div class="btn-box flex">
      <div class="btn" @click="toNextPage"></div>
    </div>
  </div>
</template>

<script>
// import { h5 } from "@/utils/env";
// import { initShare } from "@/utils";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      initShareObg: {},
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    /* this.initShareObg = new initShare({
      shareUrl: `${h5}app/v2/active/20230406-ruijie.html`,
      sharePath: "commonh5",
      imgUrl: require("@/assets/images/active/active20230406/share.png"),
      miniAppImgUrl: "https://static.shenzhoubb.com/images/miniapp/share.png",
      title: "擂台赛敢不敢来打！",
      desc: "锐捷数通工程师招募火热开启中...",
    }); */
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  //方法集合
  methods: {
    toNextPage() {
      this.$router.push({
        path: "/20230406-question.html",
      });
    },
  },
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.box {
  position: relative;
  box-sizing: border-box;
  width: 7.5rem;
  margin: 0 auto;

  img {
    display: block;
    width: 100%;
  }
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btn-box {
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  padding-bottom: 1.9rem;

  .btn {
    width: 2.39rem;
    height: 0.8rem;
    margin-left: 2.37rem;
    text-align: center;
    background: #000000;
    background-image: url(~@/assets/images/active/active20230406/16.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 0.4rem;
  }
}
</style>